<template>
    <div :class="'custom-popup-modal'">
        <div class="custom-modal-wrapper">
            <div class="customer-model-content add-new-product-model text-white">
                <button v-if="!success" class="close-btn" @click.prevent="closeModal">X</button>

                <div class="login-content add-product-wrapper">
                    <h3 class="mb-2">Dewhot Product Warranty Portal</h3>
                    <p class="mb-5" v-if="success">
                        Your account has been successfully created. We have sent you an email verification, Please verify your email. <br /><br />
                        <button class="btn btn-accent btn-default-rounded px-5" @click.prevent="closeModal">X</button>
                    </p>
                    <p class="mb-5" v-else>
                        <template v-if="form.role == 'customer'">
                            Please provide us with your personal details.<br />
                            You will receive a confirmation by email.
                        </template>
                        <template v-else>
                            Please provide us with your Company details.<br />
                            You will receive a confirmation by email.
                        </template>
                    </p>

                    <div class="register-form-wrapper input-hover-blue-bg" v-if="success == false">
                        <div class="form-group">
                            <label class="mr-3"><strong>User Type:</strong></label>
                            <label class="mr-1" for="customer">
                                <input id="customer" type="radio" v-model="form.role" value="customer" /> Customer
                            </label>
                            &nbsp;
                            <label for="reseller"> <input id="reseller" type="radio" v-model="form.role" value="reseller" /> Reseller </label>
                        </div>

                        <div class="form-group" v-if="form.role == 'reseller'">
                            <select v-model="form.reseller_type" class="baseline-input">
                                <option value="">--Select Type--</option>
                                <option :value="resellerType.value" v-bind:key="resellerType.value" v-for="resellerType in resellerTypes">{{
                                    resellerType.label
                                }}</option>
                            </select>
                        </div>

                        <div class="form-group" v-if="form.role == 'reseller'">
                            <select v-model="form.region" class="baseline-input">
                                <option value="" disabled>--Select your region--</option>
                                <option :value="region" v-bind:key="region" v-for="region in regions">{{ region }}</option>
                            </select>
                        </div>

                        <div class="form-group" v-if="form.role == 'reseller'">
                            <select v-model="form.buy_product_from" class="baseline-input">
                                <option value="">--Select distributor--</option>
                                <option
                                    :value="distributor.id"
                                    v-bind:key="distributor.company + distributor.id"
                                    v-for="distributor in distributors"
                                    >{{ distributor.company }}</option
                                >
                            </select>
                        </div>

                        <div class="form-group" v-if="form.role == 'reseller'">
                            <input type="text" v-model="form.company" autocomplete="off" placeholder="Company" class="form-control" />
                        </div>

                        <div class="form-group">
                            <input type="text" v-model="form.fname" autocomplete="off" placeholder="First Name" class="form-control" />
                        </div>
                        <div class="form-group">
                            <input type="text" v-model="form.lname" autocomplete="off" placeholder="Last Name" class="form-control" />
                        </div>
                        <div class="form-group">
                            <p class="mb-0"><small class="font-blue">Please start typing and select address from suggestions.</small></p>
                            <!-- <input type="text" v-model="form.address" autocomplete="off" placeholder="Address" class="form-control"> -->
                            <span>
                                <gmap-autocomplete
                                    id="register_address"
                                    autocomplete="nope"
                                    class="form-control"
                                    large
                                    name="Address"
                                    placeholder="Address"
                                    :select-first-on-enter="true"
                                    :componentRestrictions="{country: ['ZA']}"
                                    @place_changed="setPlace"
                                    @keyup="resetPlace"
                                >
                                </gmap-autocomplete>
                            </span>
                            <div class="address-info-wrap" v-if="form.address && form.addressDetail && form.addressDetail.province">
                                <p class="address-info"><span>Province:</span> {{ form.addressDetail.province }}</p>
                                <p class="address-info"><span>City:</span> {{ form.addressDetail.city }}</p>
                                <p class="address-info"><span>Suburb:</span> {{ form.addressDetail.suburb }}</p>
                                <p class="address-info"><span>Postcode:</span> {{ form.addressDetail.postcode }}</p>
                            </div>
                        </div>

                        <div class="form-group">
                            <input
                                type="text"
                                name="building_complex"
                                v-model="form.complex_building_unit"
                                placeholder="Complex / Building / Unit"
                                class="form-control"
                            />
                        </div>

                        <div class="form-group">
                            <input type="number" v-model="form.mobile" placeholder="Mobile number" class="form-control" />
                        </div>

                        <div class="form-group">
                            <input type="email" v-model="form.email" autocomplete="off" placeholder="Email" class="form-control" />
                        </div>

                        <div class="form-group" v-if="form.role == 'reseller'">
                            <div>
                                <p class="mb-0">Do you have website?</p>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="form.has_website"
                                        class="form-check-input"
                                        type="radio"
                                        name="haveWebsite"
                                        id="website_yes"
                                        value="1"
                                    />
                                    <label class="form-check-label" for="website_yes">Yes</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="form.has_website"
                                        class="form-check-input"
                                        type="radio"
                                        name="haveWebsite"
                                        id="website_no"
                                        value="0"
                                    />
                                    <label class="form-check-label" for="website_no">No</label>
                                </div>
                            </div>
                            <div v-if="form.has_website == 1" class="website-holder">
                                <span class="website-prefix">https://</span>
                                <input type="text" v-model="form.website" placeholder="eg: example.com" class="form-control" />
                            </div>
                        </div>

                        <div class="form-group">
                            <input type="password" v-model="form.password" autocomplete="new-password" placeholder="Password" class="form-control" />
                        </div>
                        <div class="form-group">
                            <input
                                type="password"
                                v-model="form.password_confirmation"
                                autocomplete="off"
                                placeholder="Re password"
                                class="form-control"
                            />
                        </div>
                        <!-- <div class="form-group">
                  <select class="form-control" v-model="form.role">
                    <option value="">-- Select Account Type --</option>
                    <option value="customer">Customer</option>
                    <option value="reseller">Reseller</option>
                  </select>
                </div> -->

                        <div class="form-group register-action mt-3">
                            <button @click="register()" class="px-4 btn btn-secondary btn-rounded">register</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers/index';
import Env from '@/env';

export default {
    name: 'registerForm',
    props: {
        model: Boolean,
        callback: {type: Function}
    },
    data() {
        return {
            form: {
                fname: '',
                lname: '',
                email: '',
                company: '',
                region: '',
                buy_product_from: '',
                address: '',
                complex_building_unit: '',
                addressDetail: {
                    province: '',
                    city: '',
                    suburb: '',
                    postcode: '',
                    lat: '',
                    lng: ''
                },
                mobile: '',
                role: 'customer',
                password: '',
                password_confirmation: '',
                app_path: window.location.href,
                reseller_type: '',
                website: '',
                has_website: 0
            },
            success: false,
            distributors: []
        };
    },
    watch: {
        'form.role'() {
            this.form.has_website = this.form.role == 'reseller' ? 1 : 0;
            if (this.form.role != 'reseller') {
                this.form.website = '';
            }
        }
    },
    computed: {
        regions() {
            return Env.regions;
        },
        resellerTypes() {
            return Env.resellerTypes;
        }
    },

    async mounted() {
        await this.fetchDistributors();
    },

    methods: {
        async register() {
            // there must be lat , lng
            if (!this.form.addressDetail.lat && !this.form.addressDetail.lng) {
                return this.$toasted.global.error({
                    message: 'Please select one of the address from suggestion.'
                });
            }
            this.spinner(true);
            let res = await this.va_registerNewUser(this.form);
            this.spinner(false);
            if (res.status && res.status == 200) {
                this.form = await Helpers.setObjValueEmpty(this.form);
                this.form.app_path = window.location.href;
                this.success = true;
                this.form.role = 'customer';
                // this.$toasted.global.success({
                //   message: res.data.message
                // })
            } else {
                this.$toasted.global.error({
                    message: res.response.data.errors[0]
                });
            }
        },

        fetchDistributors() {
            // this is free route
            const url = `${Env.baseUrl}/get-distributors`;
            AuthApis.getApi(url)
                .then(res => {
                    this.distributors = res.data.payload;
                })
                .catch(err => {
                    console.log(err);
                });
        },

        /**
         * autocomplete set
         */
        setPlace: async function(addressData) {
            if (_.isEmpty(addressData)) {
                return;
            }
            // console.log(addressData.formatted_address)
            this.form.address = addressData.formatted_address;
            let province = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1');
            let city = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2');
            let suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_1');
            if (!suburb) {
                suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_2');
            }
            let postcode = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
            let {lat, lng} = Helpers.getLatLngFromGoogleAutoComplete(addressData);
            this.form.addressDetail = {
                province,
                city,
                suburb,
                postcode,
                lat,
                lng
            };
        },

        resetPlace: function() {
            this.form.address = '';
            this.form.addressDetail = {
                province: '',
                city: '',
                suburb: '',
                postcode: '',
                lat: '',
                lng: ''
            };
        },

        closeModal() {
            this.success = false;
            document.getElementById('register_address').value = '';
            this.resetPlace();
            this.callback();
        },
        ...mapActions({
            va_registerNewUser: 'register_user/registerNewUser'
        })
    }
};
</script>
